import { render } from "./NotificationPill.vue?vue&type=template&id=49bd9976"
import script from "./NotificationPill.vue?vue&type=script&lang=js"
export * from "./NotificationPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__